@import 'src/styles/variabels';
@import 'src/styles/mobile';

// N1 (brief pattern B). The filters button and dialog render below md only;
// the rules sit in the md query all the same, so nothing here can reach the
// desktop.
@media (max-width: map-get($breakpoints, 'md') - 1 + px) {
  .badge {
    flex: none;
  }
  // a bottom sheet as tall as its fields, the rest of the screen dimmed above
  // it; a long sheet scrolls its fields between the pinned heading and actions.
  // Doubled: the theme stretches every dialog's paper to the full screen below
  // md from the dialog's root (two classes deep).
  .sheet.sheet {
    @include mobile-bottom-sheet('.paper');
  }
  // Doubled: the touch layer's 44 px button height outranks one class (the
  // button stood 40 x 44 beside the row's 40 x 40 squares).
  .button.button {
    @include mobile-icon-button;
    [class~='MuiSvgIcon-root'] {
      font-size: $mobile-icon-bar;
    }
  }
  // the count on the button's end corner. N2 (DC-17): fully inside the box,
  // 2 px in from its top and end edges (N1 had it 4 px above and 2 px out of
  // the box, where it bridged the gap to the next button), a 14 px disc so it
  // clears the 24 px glyph's top line (centred on the corner, MUI's, it rose
  // into the app bar)
  .badge [class~='MuiBadge-badge']:not([class~='MuiBadge-invisible']) {
    top: 0.2rem;
    right: 0.2rem;
    min-width: 1.4rem;
    height: 1.4rem;
    padding: 0 0.3rem;
    font-size: 1rem;
    transform: none;
  }
  // the heading's close on the fields' end column (the icons' centres 28 px
  // from the edge): the dialog heading pulls it 8 px into the gutter
  // N1 (T5, R1): a 40 px box like the bar's icon buttons, so its centre is on
  // that column too (the touch layer's 44 px put it 2 px in from the carets)
  .paper.paper [class*='dialog-title_close'] {
    width: $mobile-tap-dense;
    min-width: $mobile-tap-dense;
    height: $mobile-tap-dense;
    min-height: $mobile-tap-dense;
    margin-left: 0;
    margin-right: 0;
  }
  // the fields stacked full-width on the page gutter, one gap between them and
  // the same gap at the top and the foot; a field never grows into the
  // dialog's height (a grid's filter template may `flex-grow`), and its own
  // margins go (a select's 15 px bottom margin made three gaps out of one)
  .content {
    display: flex;
    flex-direction: column;
    gap: $mobile-space-l;
    padding: $mobile-space-l $mobile-gutter;
    > * {
      flex: none;
      width: 100%;
      margin: 0 !important;
    }
    [class~='MuiFormControl-root'] {
      margin: 0;
    }
    // one field anatomy, MUI's own (the desktop's): an empty field keeps its
    // label inline, a filled one floats it into the 16 px above its 44 px
    // value row. Every field keeps that 16 px -- a field without a label (a
    // date range's placeholder) and the selects whose input MUI does not
    // offset alike -- so every value row sits on one rhythm; the inline label
    // is centred on the row, on its arrow's line (MUI centres it on a 32 px
    // row). (A forced shrink left a small caption over a blank row -- it read
    // as empty.)
    // (doubled -- N1 T5, R1: a grid select's own module sets
    // `.root .MuiAutocomplete-inputRoot { min-height: 3rem }` at the same
    // weight and loads later; the weekly report's status selects and the
    // tasks category stood 32 px, their labels placed for 44)
    [class~='MuiInputBase-root'][class~='MuiInputBase-root'] {
      min-height: $mobile-tap;
    }
    [class~='MuiFormControl-root'] > [class~='MuiInputBase-root'] {
      margin-top: 1.6rem;
    }
    // N2 (DC-18 a): every label is raised -- the slot above the row is always
    // its place, so a field reads the same empty or filled -- and an empty
    // select shows its placeholder ("all", filters-dialog/context.ts) in the
    // row. MUI's standard shrink transform; MUI hides a placeholder under a
    // label it has not shrunk, hence the selects' own placeholder rule
    // (tripled: MUI's `label[data-shrink=false] + … ::placeholder` is 0,3,1).
    [class~='MuiInputLabel-root']:not([class~='MuiInputLabel-shrink']) {
      transform: translate(0, -1.5px) scale(0.75);
    }
    [class~='MuiAutocomplete-input'][class~='MuiAutocomplete-input'][class~='MuiAutocomplete-input']::placeholder {
      opacity: 0.54 !important;
    }
    // the adornments on the row's end, where the selects' arrows are -- a
    // calendar at the start pushed its date off the labels' start line -- on
    // the arrows' column (centres 28 px from the edge), in one colour at the
    // content size (the app select writes its arrow's grey inline, hence the
    // !important)
    // N1 (T5, R1): a 40 px box on the field's end edge, the icon centred in
    // it -- on the carets' column (its 8 px end margin put it 2 px out)
    [class~='MuiInputAdornment-positionStart'] {
      order: 1;
      flex: none;
      justify-content: center;
      width: $mobile-tap-dense;
      margin-left: $mobile-space-s;
      margin-right: 0;
    }
    // N2 (DC-20): in MUI's field-icon grey (N1: the brand colour)
    [class~='MuiInputAdornment-root'] [class~='MuiSvgIcon-root'],
    [class~='MuiAutocomplete-popupIndicator'] [class~='MuiSvgIcon-root'],
    [class~='MuiSelect-icon'] {
      font-size: $mobile-icon-content;
      color: $mobile-field-icon !important;
    }
    // a segmented filter fills its row at 44 px, its label the field rows' 4 px
    // above it; a grid's filter template may wrap it in boxes that push it to
    // the end (`ml: auto`)
    // (doubled: a screen's own segmented rule -- the task manager's 40 px --
    // ties one attribute deep and came later)
    [class~='MuiButtonGroup-root'][class~='MuiButtonGroup-root'] {
      @include mobile-segmented;
      > * {
        height: auto;
        min-height: $mobile-tap;
      }
    }
    // (the Stack sets its children's margin inline)
    div:has(> [class~='MuiFormLabel-root']) > [class~='MuiButtonGroup-root'] {
      margin-top: $mobile-space-xs !important;
    }
    div:has(> [class~='MuiButtonGroup-root']) {
      flex: 1 1 auto;
      width: 100%;
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
    // a switch is a settings row: the label on the start edge, the switch at
    // the end (AppSwitch puts the label first, `row-reverse`), a 44 px row
    [class~='MuiFormControlLabel-root'] {
      justify-content: space-between;
      min-height: $mobile-tap;
      margin: 0;
    }
    // N2c (T1): one solid button per sheet -- the footer's apply. A page
    // form's own contained buttons ("by me", "refresh") are a primary tint.
    [class~='MuiButton-contained'] {
      @include mobile-tint-action;
    }
  }
  // N2c (T1): a page form's filters button (PageFilters) in a grid bar takes
  // the filters slot, just before the bar's actions (D-118): first in the
  // actions box when the page renders it in the controls slot; pushed to the
  // actions when it renders it in the toolbar slot, the actions box then
  // beside it. (Doubled: the card-mode bar's `margin: 0 0 0 auto` on the
  // actions box is three classes deep.)
  .pageButton {
    order: -1;
  }
  // the actions box that holds it stays pushed to the row's end: the grid's
  // filters box is empty on these pages (the config's filters have no
  // template) and N2b's rule for a filters box without a search (five classes
  // deep) took the push away, so the actions stood at the row's start
  :global(.data-grid.is-card-mode .data-grid__toolbar)
    > :global(.data-grid__toolbar-button):has(> .pageButton.pageButton) {
    margin: 0 0 0 auto;
  }
  :global(.data-grid__toolbar) > .pageButton {
    margin: 0 0 0 auto;
  }
  :global(.data-grid__toolbar) > .pageButton.pageButton ~ :global(.data-grid__toolbar-button) {
    margin: 0;
  }
  // a page without a grid bar (the light-grid reports): a bar row of its own,
  // the button at its end like a grid bar's filters button without a search
  .pageBar {
    @include mobile-toolbar;
    justify-content: flex-end;
    flex: none;
  }
  // "clear" and "apply" share the bottom row, 44 px targets, the safe area kept
  .actions {
    gap: $mobile-space-s;
    padding: $mobile-space-s $mobile-gutter;
    padding-bottom: calc(#{$mobile-space-s} + env(safe-area-inset-bottom));
    border-top: 1px solid $color-grey-lines;
    > * {
      flex: 1 1 0;
      min-height: $mobile-tap;
      margin: 0;
    }
  }
}
